import { fetchWithAuth } from './fetchWithAuth'

export async function deleteInventorySystemProfileToVenue(
  token: string,
  ispId: string,
  venueId: string,
): Promise<void> {
  await fetchWithAuth(
    `/v1/inventory-system-profile-to-venues/${ispId}/${venueId}`,
    token,
    { method: 'DELETE' }
  )
}
